import { useCurrentWorkspace } from "src/api/queries";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";

type LiveAnalyticsAccess = {
  canAccess: boolean;
  isLoading: boolean;
};

// Live Analytics is reachable either via the frontend feature flag (dev/preview,
// driven by a URL param) or, for workspaces where it's permanently enabled, via
// the `enable_live_analytics` workspace config flag. `isLoading` lets route
// guards wait for the workspace before deciding, so they don't flash an error.
export const useLiveAnalyticsAccess = (): LiveAnalyticsAccess => {
  const { data: workspace, isLoading } = useCurrentWorkspace();
  const canAccess =
    isFeatureFlagEnabled(FEATURE_FLAGS.liveAnalytics) ||
    Boolean(workspace?.config?.enable_live_analytics);
  return { canAccess, isLoading };
};
